export default __webpack_public_path__ + "static/media/bgHead.6df35f22.png";